/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CameraEventReplayDecision = {
    Replay: 'Replay',
    NotEntry: 'NotEntry',
    SamePass: 'SamePass',
    PlateFragment: 'PlateFragment',
    AlreadyReceived: 'AlreadyReceived',
    SeenLater: 'SeenLater',
    ActiveInOtherZone: 'ActiveInOtherZone',
    Superseded: 'Superseded',
    AlreadyReplayed: 'AlreadyReplayed'
} as const;
export type CameraEventReplayDecision = typeof CameraEventReplayDecision[keyof typeof CameraEventReplayDecision];

